import React from 'react'
import { List, Antd, Button } from 'components'
import { navigate} from 'gatsby'
import { Link } from 'gatsby'
import PropTypes from "prop-types"
import * as S from './styles'
import theme from "../../../style/theme";
const Icon = Antd.Icon

const Footer = ({title, locationsTitle, locations, linksTitle, links, socialsTitle, pathPrefix, contactUsSlug}) => {

  return (
    <S.Footer>
      {contactUsSlug && <S.ContactUsButtonWrapper>
        <Button color={theme.colors.secondary} size="large" onClick={() =>  navigate(contactUsSlug)}>Contact us</Button>
      </S.ContactUsButtonWrapper> }
      <S.LogoWrapper>
        <img loading="lazy"  src={`${pathPrefix}/logo-light-full.svg`} alt="" />
      </S.LogoWrapper>


      <List columns="4">
        <S.Column>
          <S.ColumnTitle>
            {title}
          </S.ColumnTitle>
          <S.ColumnText>
            <a href="https://www.e-globe-solutions.com/" target="_blank" rel="noopener noreferrer">
              <img loading="lazy"  src={`${pathPrefix}/e-globe-solutions-logo-white.png`} alt="" />
            </a>
          </S.ColumnText>
         
        </S.Column>

        <S.Column>
          <S.ColumnTitle>
            {locationsTitle}
          </S.ColumnTitle>
          {locations.map(({city, address, phone}) => 
            <S.ColumnText key={address}>
              <div> {address}</div>
              <div> {city}</div>
              <div>{phone}</div>
            </S.ColumnText>
          )}
        </S.Column>

        <S.Column>
          <S.ColumnTitle>
            {linksTitle}
          </S.ColumnTitle>
          {links.map(({slug, label, external}) => 
            <S.ColumnText key={slug}>
              {
                external
                  ? <a href={slug} target="_blank" rel="noopener noreferrer">{label}</a>
                  : <Link key={slug} to={slug}>{label}</Link>
              }
            </S.ColumnText>
          )}
        </S.Column>
        <S.Column>
          <S.ColumnTitle>
            {socialsTitle}
          </S.ColumnTitle>
          <a href={"https://www.linkedin.com/company/godoo-ch"}>
            <S.SocialIconWrapper>
              <Icon size="big" type="linkedin" />
            </S.SocialIconWrapper>
          </a>
        </S.Column>
      </List>
    </S.Footer>
  )
}




Footer.propTypes = {
  title: PropTypes.string.isRequired,
  pathPrefix: PropTypes.string.isRequired,
  contactUsSlug: PropTypes.string,
  locationsTitle: PropTypes.string.isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({
    city: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
  })).isRequired,
  linksTitle: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
}

export default Footer
